import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

/**
 * &nbsp;
 *
 * # Description
 * Fires on the sitter profile revamp when the "What sitter wants to know"
 * accordion section is expanded.
 *
 * &nbsp;
 */
export class SitterProfileWhatSitterWantsToKnowExpandEvent extends AnalyticsEvent {
  eventName = 'sitter-profile-what-sitter-wants-to-know-expand';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.provider_profile;
}
